export default __webpack_public_path__ + "static/media/logo2.6516c79c.jpg";